<script setup lang="ts">
import { computed } from 'vue';

import type { AppWhiteDotSize } from './AppWhiteDot.model';

export interface AppWhiteDotProps {
  size: AppWhiteDotSize;
}

const props = defineProps<AppWhiteDotProps>();

const style = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<template>
  <div class="white-dot" :style="style" />
</template>

<style scoped lang="scss">
.white-dot {
  background: white;
  border-radius: 50%;
}
</style>
